// extracted by mini-css-extract-plugin
export default {"base":"WidgetHeaderTimer_base__BPg9h"};